























































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component } from 'vue-property-decorator';
import { ChevronDownIcon, ChevronUpIcon, FilterIcon } from 'vue-feather-icons';
import { DateFilter, IProduct, IUser, LeadFilter } from 'admiral-core';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import { PreferencesAction } from '@/store/PreferencesModule';
import DateFilterComponent from '@/components/filters/DateFilter.vue';
import UserFilterComponent from '@/components/filters/UserFilter.vue';
import ProductFilterComponent from '@/components/filters/ProductFilter.vue';

@Component({
  components: {
    'date-filter': DateFilterComponent,
    'user-filter': UserFilterComponent,
    'product-filter': ProductFilterComponent,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
  },
})
export default class GenericFilter extends mixins(FilterMixin) {
  filter: LeadFilter = {
    dateFilter: DateFilter.ALL,
    products: [],
    users: [],
  };

  openedFilter = false;

  get isDefaultFilter() {
    return (
      this.filter.dateFilter === DateFilter.ALL &&
      this.filter.products?.length === 0 &&
      this.filter.users?.length === 0
    );
  }

  updateDateFilter(filter: { dateFilter: DateFilter; from: number; to: number }) {
    this.filter.dateFilter = filter.dateFilter;
    if (filter.from) {
      this.filter.from = filter.from;
    }
    if (filter.to) {
      this.filter.to = filter.to;
    }
    this.updateFilter();
  }

  updateUserFilter(users: IUser[]) {
    this.filter.users = [...users];
    this.updateFilter();
  }

  updateProductFilter(products: IProduct[]) {
    this.filter.products = [...products];
    this.updateFilter();
  }

  resetFilter() {
    this.filter = {
      dateFilter: DateFilter.ALL,
      products: [],
      users: [],
    };
    this.filter.users = [];
    this.filter.dateFilter = DateFilter.ALL;
    this.updateFilter();
  }

  async mounted() {
    try {
      this.filter = await this.$store.getters['PreferencesModule/getLeadFilter'];
    } catch (e) {
      this.$toastr.e('Beim Abrufen der Produkte und Mitarbeiter ist etwas schiefgelaufen.');
    }
  }

  async updateFilter() {
    if (this.filter.users && !Array.isArray(this.filter.users)) {
      this.filter.users = [this.filter.users];
    }
    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.setLeadFilter}`, this.filter);
    this.$root.$emit('get-leLeads-filter', this.filter);
  }

  toggleMoreFilter() {
    this.openedFilter = !this.openedFilter;
  }
}
